import { render, staticRenderFns } from "./pzv-dyn.vue?vue&type=template&id=bd7b42c0&"
import script from "./pzv-dyn.vue?vue&type=script&lang=js&"
export * from "./pzv-dyn.vue?vue&type=script&lang=js&"
import style0 from "./pzv-dyn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports